export const ShoppingContactType = {
    contact: "CONTACT",
    passenger: "PASSENGER",
}

export const ShoppingShopTab = {
    transport: "TRANSPORT",
    voucher: "VOUCHER"
}

export const ShoppingFillIndividualDetailSource = {
    individualSearch: 'individualSearch',
    individualAttribute: 'individualAttribute'
}
export const ProductNumberType = {
    marketing: 'MARKETING',
    operating: 'OPERATING'
}

export const Attribute = {
    individualTitle: 'INDIVIDUALTITLE',
    individualGender: 'INDIVIDUALGENDER',
    membership: 'MEMBERSHIP',
    identityDocument: 'IDENTITYDOCUMENT',
    required: 'REQUIRED',
    allowed: 'ALLOWED',
    yes: 'YES'
}

export const IndividualCheckDisableInput = {
    lastName: 'lastName',
    mailAddress: 'mailAddress'
}